<template>
  <div id="homeView">
    <!-- APPBAR (novo design DS V2 — NavBar antigo suprimido em Base.vue) -->
    <header class="vm-appbar">
      <router-link to="/" class="vm-mark" @click.native="clearQuery">
        <img
          class="vm-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </router-link>

      <div
        id="vm-appbar-menu"
        class="vm-appbar-menu"
        :class="{ 'is-open': menuOpen }"
      >
        <nav class="vm-appnav">
          <router-link to="/" exact active-class="is-active">
            Início
          </router-link>
          <router-link
            :to="{ path: '/', query: { buscar: '1' } }"
            active-class="is-active"
          >
            Buscar profissionais de saúde
          </router-link>
          <router-link v-if="loggedIn" to="/consultas" active-class="is-active">
            Minhas consultas
          </router-link>
          <router-link
            v-if="loggedIn"
            to="/documentos"
            active-class="is-active"
          >
            Documentos
          </router-link>
          <router-link
            v-if="loggedIn"
            to="/meus-pagamentos"
            active-class="is-active"
          >
            Pagamentos
          </router-link>
        </nav>

        <span class="vm-appbar-spacer" />

        <div v-if="!(loggedIn && currentUser)" class="vm-appbar-auth">
          <router-link to="/login" class="btn btn--ghost btn--sm">
            Entrar
          </router-link>
          <router-link to="/cadastrar" class="btn btn--outline btn--sm">
            Cadastrar
          </router-link>
        </div>
      </div>

      <!-- <router-link
        :to="{ path: '/', query: { buscar: '1' } }"
        class="btn btn--accent btn--sm"
      >
        Agendar consulta
      </router-link> -->

      <template v-if="loggedIn && currentUser">
        <span class="appbar-icon" aria-label="Notificações">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.3 21a1.94 1.94 0 0 0 3.4 0"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <!-- <span class="dot" /> -->
        </span>
        <AppBarUserMenu />
      </template>

      <button
        type="button"
        class="navbar-toggler vm-appbar-toggler"
        :class="menuOpen ? 'not-collapsed' : 'collapsed'"
        aria-controls="vm-appbar-menu"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        :aria-label="menuOpen ? 'Fechar menu' : 'Abrir menu'"
        @click="menuOpen = !menuOpen"
      >
        <div class="animated-icon">
          <span />
          <span />
          <span />
          <span />
        </div>
      </button>
    </header>

    <!-- Estado: com query → resultados de busca -->
    <medical-search v-if="hasQuery" />

    <!-- Estado: logado → hub autenticado -->
    <template v-else-if="loggedIn">
      <div class="area">
        <VerificationPendingBanner />

        <div class="area-head">
          <div>
            <h1 class="greet">Olá, {{ userFirstName }}</h1>
            <p class="sub">Bem-vindo de volta · {{ todayLabel }}</p>
          </div>
          <router-link
            :to="{ path: '/', query: { buscar: '1' } }"
            class="btn btn--accent btn--lg"
          >
            Agendar consulta
          </router-link>
        </div>

        <!-- PRÓXIMA CONSULTA -->
        <section v-if="nextAppointment">
          <div class="hub-sec-head">
            <div>
              <h2>Próxima consulta</h2>
              <p class="sub">
                {{ nextApptCountdown }} · a sala abre 10 min antes
              </p>
            </div>
            <router-link to="/consultas" class="seelink">
              Minhas consultas →
            </router-link>
          </div>
          <div class="card next-appt">
            <div class="when">
              <div class="d">{{ formatDay(nextAppointment.scheduled_at) }}</div>
              <div class="h">
                {{ formatTime(nextAppointment.scheduled_at) }}
              </div>
            </div>
            <div class="stack next-appt-info">
              <div class="row next-appt-doc">
                <div class="avatar avatar--md avatar--ring">
                  <img
                    v-if="
                      nextAppointment.doctor && nextAppointment.doctor.photo
                    "
                    :src="nextAppointment.doctor.photo"
                    :alt="nextAppointment.doctor.name"
                    loading="lazy"
                    decoding="async"
                  />
                  <template v-else>
                    {{ doctorInitials(nextAppointment) }}
                  </template>
                </div>
                <div class="stack next-appt-text">
                  <span class="next-appt-name">
                    {{ nextAppointment.doctor && nextAppointment.doctor.name }}
                  </span>
                  <span class="next-appt-meta">
                    {{ nextApptSpecialty }}
                    <template v-if="nextApptCrm">· {{ nextApptCrm }}</template>
                    · por vídeo
                    <template v-if="nextApptDuration">
                      · {{ nextApptDuration }} min
                    </template>
                  </span>
                </div>
                <span class="badge badge--success">Confirmada</span>
              </div>
            </div>
            <button
              v-if="nextAppointment.room"
              class="btn btn--accent next-appt-cta"
              @click="enterWaitingRoom(nextAppointment)"
            >
              Entrar na sala
            </button>
            <span v-else class="next-appt-cta next-appt-wait">
              Aguardando profissional de saúde criar sala
            </span>
          </div>
          <p v-if="roomError" class="next-appt-error">{{ roomError }}</p>
        </section>

        <section
          v-else
          class="card"
          style="padding:var(--space-6);text-align:center;color:var(--color-gray-400)"
        >
          <p style="margin:0">
            Nenhuma consulta agendada.
            <router-link
              :to="{ path: '/', query: { buscar: '1' } }"
              style="color:var(--color-primary)"
            >
              Agendar agora →
            </router-link>
          </p>
        </section>

        <!-- 2 COLUNAS -->
        <div class="hub-2col">
          <!-- COLUNA ESQUERDA -->
          <div class="hub-col" style="gap:var(--space-8)">
            <section>
              <div class="hub-sec-head">
                <div><h2>Atalhos</h2></div>
              </div>
              <div class="quick-grid">
                <router-link
                  :to="{ path: '/', query: { buscar: '1' } }"
                  class="card card--interactive quick-card"
                >
                  <span class="ic">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="11"
                        cy="11"
                        r="7"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M21 21l-4-4"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Buscar profissional de saúde</b>
                    <span>40+ especialidades</span>
                  </div>
                </router-link>
                <router-link
                  :to="{ path: '/', query: { buscar: '1', expresso: '1' } }"
                  class="card card--interactive quick-card"
                >
                  <span class="ic ic--success">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Ser atendido agora</b>
                    <span>Clínico em ~30 min</span>
                  </div>
                </router-link>
                <router-link
                  to="/consultas"
                  class="card card--interactive quick-card"
                >
                  <span class="ic">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="17"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M3 9h18M8 2v4M16 2v4"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Minhas consultas</b>
                    <span>{{ futureCount }} agendadas</span>
                  </div>
                </router-link>
                <router-link
                  to="/documentos"
                  class="card card--interactive quick-card"
                >
                  <span class="ic ic--accent">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14 2v6h6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Meus documentos</b>
                    <span>Receitas e atestados</span>
                  </div>
                </router-link>
              </div>
            </section>

            <section>
              <div class="hub-sec-head">
                <div><h2>Documentos recentes</h2></div>
                <router-link to="/documentos" class="seelink">
                  Ver todos →
                </router-link>
              </div>
              <div v-if="recentDocuments.length" class="card card--flush">
                <div class="doc-files">
                  <div
                    v-for="doc in recentDocuments"
                    :key="`${doc._type}-${doc.id}`"
                    class="docfile"
                  >
                    <div class="doc-type">
                      <span
                        class="ic"
                        :class="
                          doc._type === 'receita'
                            ? 'ic--rx'
                            : doc._type === 'atestado'
                            ? 'ic--at'
                            : 'ic--ex'
                        "
                      >
                        <svg
                          v-if="doc._type === 'receita'"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 2v6h6M9 13h6M9 17h4"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                        <svg
                          v-else-if="doc._type === 'atestado'"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 11l3 3L22 4"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <svg
                          v-else
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <span
                        class="badge badge--no-dot"
                        :class="
                          doc._type === 'receita'
                            ? 'badge--info'
                            : doc._type === 'atestado'
                            ? 'badge--success'
                            : ''
                        "
                      >
                        {{
                          doc._type === "receita"
                            ? "Receita"
                            : doc._type === "atestado"
                            ? "Atestado"
                            : "Exame"
                        }}
                      </span>
                    </div>
                    <div class="info">
                      <b v-b-tooltip.hover.top="docTitle(doc)">
                        {{ shortDocTitle(doc) }}
                      </b>
                      <span class="num">
                        {{
                          new Date(
                            doc.prescription_date || doc.created_at
                          ).toLocaleDateString("pt-BR")
                        }}
                      </span>
                    </div>
                    <div class="acts">
                      <button
                        type="button"
                        class="btn btn--ghost btn--sm"
                        @click="openDocument(doc)"
                      >
                        Ver
                      </button>
                      <button
                        v-if="doc.links || doc.file_url"
                        class="btn btn--outline btn--sm"
                        @click="downloadFile(doc)"
                      >
                        Baixar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="card"
                style="padding:var(--space-8) var(--space-6);display:flex;flex-direction:column;align-items:center;text-align:center;gap:var(--space-2)"
              >
                <span
                  style="font-size:var(--font-size-sm);color:var(--color-gray-500)"
                >
                  Nenhum documento disponível ainda.
                </span>
                <router-link to="/documentos" class="btn btn--ghost btn--sm">
                  Ver documentos
                </router-link>
              </div>
            </section>
          </div>

          <!-- COLUNA DIREITA -->
          <div class="hub-col" style="gap:var(--space-6)">
            <section v-if="pendingPaymentAppt || nextAppointment">
              <div class="hub-sec-head">
                <div><h2>Continuar</h2></div>
              </div>
              <div class="cont-stack">
                <router-link
                  v-if="pendingPaymentAppt"
                  :to="'/pagamento/' + pendingPaymentAppt.id"
                  class="card card--warning cont-card tap"
                >
                  <span
                    class="ic"
                    style="background:var(--color-warning-light);color:var(--color-warning)"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M12 7v5l3 2"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Pagamento pendente</b>
                    <span>
                      {{
                        pendingPaymentAppt.doctor &&
                          pendingPaymentAppt.doctor.name
                      }}
                      · PIX
                    </span>
                  </div>
                  <span
                    style="color:var(--color-warning);font-size:var(--font-size-lg)"
                  >
                    ›
                  </span>
                </router-link>
                <router-link
                  v-if="nextAppointment"
                  :to="
                    nextAppointment.room
                      ? '/sala-de-espera/' + nextAppointment.room.id
                      : '/consultas'
                  "
                  class="card cont-card tap"
                >
                  <span
                    class="ic"
                    style="background:var(--color-primary-light);color:var(--color-primary)"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="6"
                        width="14"
                        height="12"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M16 10l6-3v10l-6-3"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <div class="tx">
                    <b>Próxima consulta</b>
                    <span>
                      {{ formatDay(nextAppointment.scheduled_at) }} ·
                      {{ formatTime(nextAppointment.scheduled_at) }}
                    </span>
                  </div>
                  <span
                    style="color:var(--color-primary);font-size:var(--font-size-lg)"
                  >
                    ›
                  </span>
                </router-link>
              </div>
            </section>

            <div class="card" style="padding:var(--space-5)">
              <div class="hub-sec-head" style="margin-bottom:var(--space-4)">
                <div><h2 style="font-size:var(--font-size-lg)">Resumo</h2></div>
              </div>
              <div class="mini-stats">
                <div class="mini-stat">
                  <div class="v">{{ pastCount }}</div>
                  <div class="l">Consultas realizadas</div>
                </div>
                <div class="mini-stat">
                  <div class="v">{{ documentsCount }}</div>
                  <div class="l">Documentos</div>
                </div>
                <div class="mini-stat">
                  <div class="v">{{ futureCount }}</div>
                  <div class="l">Agendadas</div>
                </div>
              </div>
            </div>

            <div
              class="card"
              style="background:var(--color-primary-light);border-color:transparent;padding:var(--space-5);display:flex;gap:var(--space-3);align-items:flex-start"
            >
              <span
                class="avatar avatar--sm"
                style="background:#fff;color:var(--color-primary);flex-shrink:0"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M12 16v-4M12 8h.01"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
              <div class="stack" style="gap:var(--space-2)">
                <span
                  style="font-size:var(--font-size-sm);font-weight:var(--fw-bold);color:var(--color-primary-dark)"
                >
                  Precisa de ajuda?
                </span>
                <span
                  style="font-size:var(--font-size-xs);color:var(--color-gray-600);line-height:1.5"
                >
                  Nossa equipe responde em minutos pelo chat, de segunda a
                  domingo.
                </span>
                <a
                  href="#"
                  style="font-size:var(--font-size-xs);font-weight:var(--fw-bold);color:var(--color-primary)"
                >
                  Falar com suporte →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="foot-mini">
        <router-link to="/" class="vm-mark">
          <img
            class="vm-logo vm-logo--sm"
            src="../assets/images/logo-videomedi.png"
            alt="Videomedi"
          />
        </router-link>
        <span class="cpy">© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
        <div class="links">
          <a href="#">Privacidade</a>
          <a href="#">Termos de Uso</a>
          <a href="#">LGPD</a>
          <a href="#">Suporte</a>
        </div>
      </footer>
    </template>

    <!-- Estado: sem query → landing pública -->
    <template v-else>
      <div class="hub">
        <!-- HERO -->
        <section class="hub-hero">
          <div class="hub-hero-text">
            <h1>
              Um profissional de saúde online,
              <br />
              em minutos.
            </h1>
            <p class="lead">
              Consulta por vídeo com especialistas, com receita e atestado
              digitais — sem sair de casa.
            </p>
            <div class="web-search" @click="goToSearch">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <circle
                  cx="11"
                  cy="11"
                  r="7"
                  stroke="#1A6CF7"
                  stroke-width="2"
                />
                <path
                  d="M21 21l-4-4"
                  stroke="#1A6CF7"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <span class="web-search-placeholder">
                Buscar especialidade ou profissional de saúde
              </span>
              <button class="btn btn--accent btn--sm" @click.stop="goToSearch">
                Buscar
              </button>
            </div>
          </div>
          <div class="card card-atend-agora" @click="goToExpressSearch">
            <div
              class="avatar avatar--md"
              style="background:var(--color-success-light);color:var(--color-success);flex-shrink:0"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="stack" style="gap:2px;flex:1">
              <span
                style="font-size:var(--font-size-md);font-weight:var(--fw-bold);color:var(--color-success)"
              >
                Ser atendido agora
              </span>
              <span
                style="font-size:var(--font-size-sm);color:var(--color-gray-600)"
              >
                Clínico geral disponível em ~30 min · sem agendamento
              </span>
            </div>
            <span
              style="color:var(--color-success);font-size:var(--font-size-xl)"
            >
              ›
            </span>
          </div>
        </section>

        <!-- ESPECIALIDADES POPULARES -->
        <section class="hub-section">
          <div class="hub-sec-head">
            <div>
              <h2>Especialidades populares</h2>
              <p class="sub">Mais de 40 especialidades disponíveis</p>
            </div>
            <a class="seelink" @click.prevent="goToSearch">Ver todas →</a>
          </div>
          <div class="esp-grid">
            <div
              v-for="spec in popularSpecialties"
              :key="spec.id || spec.name"
              class="card card--interactive esp-card"
              @click="searchBySpecialty(spec.id)"
            >
              <div class="ic" v-html="spec.icon" />
              <span>{{ spec.name }}</span>
            </div>
          </div>
        </section>

        <!-- AVALIAÇÕES -->
        <section class="hub-section">
          <div class="hub-sec-head">
            <div>
              <h2>O que dizem os pacientes</h2>
              <p class="sub">Avaliações verificadas de consultas realizadas</p>
            </div>
          </div>
          <div class="rev-grid">
            <div
              class="card rev-card"
              v-for="(rev, i) in displayReviews"
              :key="i"
            >
              <span class="stars-sm">★★★★★</span>
              <p class="q">"{{ rev.description }}"</p>
              <div class="who">
                <div class="avatar avatar--sm">{{ rev.initials }}</div>
                <div class="stack" style="gap:0">
                  <span
                    style="font-size:var(--font-size-sm);font-weight:var(--fw-bold);color:var(--color-gray-900)"
                  >
                    {{ rev.patient_name }}
                  </span>
                  <span
                    style="font-size:var(--font-size-xs);color:var(--color-gray-500)"
                  >
                    {{ rev.specialty || "Consulta online" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- BENEFÍCIOS -->
        <section class="hub-section">
          <div class="hub-sec-head">
            <div><h2>Tudo o que você precisa em um só lugar</h2></div>
          </div>
          <div class="ben-grid">
            <div class="card ben-card">
              <div class="ic">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 2v6h6M9 13h6M9 17h4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <h4>Receita Digital</h4>
              <p>Válida em qualquer farmácia, assinada digitalmente.</p>
            </div>
            <div class="card ben-card">
              <div class="ic">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="2"
                    y="6"
                    width="14"
                    height="12"
                    rx="2"
                    stroke="currentColor"
                    stroke-width="2"
                  />
                  <path
                    d="M16 10l6-3v10l-6-3"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h4>Atendimento por Vídeo</h4>
              <p>Consulta em HD direto pelo navegador, sem app.</p>
            </div>
            <div class="card ben-card">
              <div class="ic">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2l8 4v5c0 5-3.5 9-8 11-4.5-2-8-6-8-11V6z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 12l2 2 4-4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h4>Especialistas Verificados</h4>
              <p>CRM conferido e avaliações reais de pacientes.</p>
            </div>
          </div>
        </section>
      </div>

      <!-- FOOTER fora do .hub → full-width sem hacks de margem -->
      <AppFooter />
    </template>

    <document-view-modal ref="documentViewModal" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { format, parseISO } from "date-fns";
import { pt as ptLocale } from "date-fns/locale";
import MedicalSearch from "../components/Search/MedicalSearch.vue";
import AppBarUserMenu from "../components/AppBarUserMenu.vue";
import AppFooter from "../components/AppFooter.vue";
import VerificationPendingBanner from "../components/VerificationPendingBanner.vue";
import DocumentViewModal from "../components/DocumentViewModal.vue";

// Título (descrição/medicamentos) é cortado em "Documentos recentes" — o texto
// completo aparece no tooltip do Bootstrap Vue, como na DocumentosView.
const TITLE_MAX = 20;

const SPECIALTY_ICONS = {
  Cardiologia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 21s-7-4.5-9.5-9C1 8.5 3 5 6.5 5 9 5 12 8 12 8s3-3 5.5-3C21 5 23 8.5 21.5 12c-2.5 4.5-9.5 9-9.5 9z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
  Dermatologia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M8 13a4 4 0 0 0 8 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="9" cy="9" r="1" fill="currentColor"/><circle cx="15" cy="9" r="1" fill="currentColor"/></svg>',
  Pediatria:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/><path d="M5 21c0-4 3-6 7-6s7 2 7 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  Psiquiatria:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 2a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 2 5 3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M15 8a3 3 0 0 1 3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  Nutrição:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 7c0-3 2-4 4-4-1 3-2 4-4 4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 7c3.5 0 6 2.5 6 6.5S15 22 12 22s-6-4-6-8.5S8.5 7 12 7z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
  Endocrinologia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3v6m0 12a5 5 0 0 0 5-5c0-3-5-7-5-7s-5 4-5 7a5 5 0 0 0 5 5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
  Ginecologia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="5" stroke="currentColor" stroke-width="2"/><path d="M12 13v8M9 18h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  Ortopedia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M7 4a2 2 0 1 0 0 4M7 20a2 2 0 1 0 0-4M17 4a2 2 0 1 1 0 4M17 20a2 2 0 1 1 0-4M9 6h6M9 18h6M10 8l4 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  "Clínico Geral":
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 3v6a6 6 0 0 0 12 0V3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M6 3h2M16 3h2M18 14a3 3 0 0 1 3 3v1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  Psicologia:
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>'
};

const POPULAR_ORDER = [
  "Cardiologia",
  "Dermatologia",
  "Pediatria",
  "Psiquiatria",
  "Nutrição",
  "Endocrinologia",
  "Ginecologia",
  "Ortopedia",
  "Clínico Geral",
  "Psicologia"
];

const STATIC_REVIEWS = [
  {
    patient_name: "João P.",
    description:
      "Consegui consulta no mesmo dia e a receita chegou em minutos. Resolveu sem eu sair de casa.",
    specialty: "Clínico Geral",
    initials: "JP"
  },
  {
    patient_name: "Camila L.",
    description:
      "Médica muito atenciosa, explicou tudo com calma. A plataforma é simples de usar.",
    specialty: "Dermatologia",
    initials: "CL"
  },
  {
    patient_name: "Rafael T.",
    description:
      "Atendimento pontual e o atestado já veio digital e válido. Recomendo demais.",
    specialty: "Psiquiatria",
    initials: "RT"
  }
];

export default {
  name: "HomeView",
  components: {
    MedicalSearch,
    AppBarUserMenu,
    AppFooter,
    VerificationPendingBanner,
    DocumentViewModal
  },
  data() {
    return {
      roomError: null,
      menuOpen: false
    };
  },
  mounted() {
    document.body.className = "";
    document.body.classList.add("Base");
    this.$store.dispatch("speciality/fetchAllSpecialities").catch(() => {});
    if (this.$store.getters["auth/loggedIn"]) {
      this.$store
        .dispatch("appointments/fetchFutureAppointments")
        .catch(() => {});
      this.$store
        .dispatch("appointments/fetchPastAppointments")
        .catch(() => {});
      this.$store
        .dispatch("prescriptions/fetchRecentPatientDocuments")
        .catch(() => {});
    }
  },
  methods: {
    ...mapActions("room", ["createRoomV2"]),

    async downloadFile(doc) {
      const url = doc.links || doc.file_url;
      const filename = url.split("/").pop();
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(blobUrl);
      } catch {
        window.open(url, "_blank");
      }
    },

    docTitle(doc) {
      if (doc._type === "receita") return this.prescriptionTitle(doc);
      if (doc._type === "atestado") return doc.description || "Atestado médico";
      return doc.description || "Pedido de exame";
    },

    shortDocTitle(doc) {
      const title = this.docTitle(doc);
      return title.length > TITLE_MAX
        ? `${title.slice(0, TITLE_MAX)}...`
        : title;
    },

    prescriptionTitle(doc) {
      const names = (doc.drugs || []).map(d => d.name).filter(Boolean);
      return names.length ? names.join(", ") : "Memed · assinada digitalmente";
    },

    openDocument(doc) {
      this.$refs.documentViewModal.open(doc, () => this.refreshDocument(doc));
    },

    async refreshDocument(doc) {
      await this.$store.dispatch("prescriptions/fetchRecentPatientDocuments");
      return this.$store.getters["prescriptions/recentPatientDocuments"].find(
        d => d.id === doc.id && d._type === doc._type
      );
    },

    async enterWaitingRoom(appointment) {
      this.roomError = null;
      if (appointment.room && appointment.room.id) {
        this.$router.push({
          name: "WaitingRoom",
          params: { room: appointment.room.id }
        });
        return;
      }
      try {
        const res = await this.createRoomV2(appointment.id);
        this.$router.push({
          name: "WaitingRoom",
          params: { room: res.data.id }
        });
      } catch {
        this.roomError = "Não foi possível preparar a sala. Tente novamente.";
      }
    },

    formatDay(iso) {
      return format(parseISO(iso), "EEE · d MMM", { locale: ptLocale });
    },
    formatTime(iso) {
      return format(parseISO(iso), "HH:mm");
    },
    doctorInitials(appt) {
      const name = (appt.doctor && appt.doctor.name) || "";
      return (
        name
          .split(" ")
          .slice(0, 2)
          .map(n => n[0])
          .join("")
          .toUpperCase() || "?"
      );
    },
    clearQuery() {
      localStorage.removeItem("specialty");
      localStorage.removeItem("from_date");
      localStorage.removeItem("until_date");
      localStorage.removeItem("selectedDoctor");
      this.$router.push({ path: "/", query: {} }).catch(() => {});
    },
    goToSearch() {
      this.$router.push({ path: "/", query: { buscar: "1" } });
    },
    goToExpressSearch() {
      this.$router.push({ path: "/", query: { buscar: "1", expresso: "1" } });
    },
    searchBySpecialty(specialtyId) {
      const query = specialtyId ? { specialty: specialtyId } : { buscar: "1" };
      this.$router.push({ path: "/", query });
    }
  },
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    ...mapGetters("user", ["getCurrentUser"]),
    currentUser() {
      return this.getCurrentUser || null;
    },
    userInitials() {
      const name = this.currentUser && this.currentUser.name;
      if (!name) return "";
      return name
        .split(" ")
        .map(p => p[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
    },
    userFirstName() {
      const name = this.currentUser && this.currentUser.name;
      if (!name) return "";
      return name.split(" ")[0];
    },
    hasQuery() {
      return Object.keys(this.$route.query).length > 0;
    },
    todayLabel() {
      return format(new Date(), "EEEE, d 'de' MMMM 'de' yyyy", {
        locale: ptLocale
      });
    },
    nextAppointment() {
      const list = this.$store.getters["appointments/futureAppointments"] || [];
      return list[0] || null;
    },
    futureCount() {
      return (this.$store.getters["appointments/futureAppointments"] || [])
        .length;
    },
    pastCount() {
      return (this.$store.getters["appointments/pastAppointments"] || [])
        .length;
    },
    popularSpecialties() {
      const all = this.$store.getters["speciality/specialities"] || [];
      const sorted = POPULAR_ORDER.map(name => {
        const found = all.find(s => s.name === name);
        return found ? { ...found, icon: SPECIALTY_ICONS[name] || "" } : null;
      }).filter(Boolean);
      if (sorted.length) return sorted;
      return POPULAR_ORDER.map(name => ({
        id: null,
        name,
        icon: SPECIALTY_ICONS[name] || ""
      }));
    },
    displayReviews() {
      return STATIC_REVIEWS;
    },
    nextApptCountdown() {
      if (!this.nextAppointment) return "";
      const diff = Math.ceil(
        (parseISO(this.nextAppointment.scheduled_at) - new Date()) / 86400000
      );
      if (diff <= 0) return "Hoje";
      if (diff === 1) return "Em 1 dia";
      return `Em ${diff} dias`;
    },
    nextApptSpecialty() {
      if (!this.nextAppointment) return "";
      return (
        (this.nextAppointment.specialty &&
          this.nextAppointment.specialty.name) ||
        (this.nextAppointment.doctor &&
          this.nextAppointment.doctor.specialty) ||
        ""
      );
    },
    nextApptCrm() {
      const dp =
        this.nextAppointment &&
        this.nextAppointment.doctor &&
        this.nextAppointment.doctor.doctor_property;
      if (!dp || !dp.council_number) return "";
      return `${dp.council_name || "CRM"} ${dp.council_number}${
        dp.council_uf ? " " + dp.council_uf : ""
      }`;
    },
    nextApptDuration() {
      const a = this.nextAppointment;
      if (!a || !a.scheduled_at || !a.scheduled_until) return null;
      return Math.round(
        (new Date(a.scheduled_until) - new Date(a.scheduled_at)) / 60000
      );
    },
    pendingPaymentAppt() {
      const list = this.$store.getters["appointments/futureAppointments"] || [];
      return (
        list.find(
          a =>
            a.payment_status === "pending" ||
            a.payment_status === "waiting_payment"
        ) || null
      );
    },
    recentDocuments() {
      return this.$store.getters["prescriptions/recentPatientDocuments"].slice(
        0,
        3
      );
    },
    documentsCount() {
      return this.$store.getters["prescriptions/patientDocumentsTotalCount"];
    }
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-logo {
  display: block;
  height: 28px;
  width: auto;
}

.vm-logo--sm {
  height: 20px;
}

// ============================================================
// ROOT
// ============================================================
#homeView {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg-page);
}

// ============================================================
// APPBAR — ícone de notificação (não existe no global)
// ============================================================
.appbar-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray-500);
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: var(--color-gray-100);
    color: var(--color-gray-800);
  }

  .dot {
    position: absolute;
    top: 7px;
    right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-accent);
    border: 2px solid #fff;
  }
}

.appbar-user {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;

  .nm {
    font-size: var(--font-size-sm);
    font-weight: var(--fw-bold);
    color: var(--color-gray-800);
  }
}

// ============================================================
// PUBLIC LANDING
// ============================================================
.hub {
  padding: var(--space-8) var(--space-10);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  flex: 1;

  @media (max-width: 768px) {
    padding: var(--space-6) var(--space-5);
    gap: var(--space-8);
  }
}

// ============================================================
// HERO: card com gradiente, 2 colunas (texto+busca | card agora)
// ============================================================
.hub-hero {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: var(--space-10);
  align-items: center;
  background: linear-gradient(150deg, #fff 0%, var(--color-primary-light) 100%);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-xl);
  padding: var(--space-10);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: var(--space-6);
    padding: var(--space-6);
  }

  h1 {
    font-family: var(--font-sans);
    font-size: 2.6rem;
    font-weight: var(--fw-extra);
    color: var(--color-gray-900);
    letter-spacing: -0.02em;
    line-height: 1.05;
    margin: 0;

    @media (max-width: 960px) {
      font-size: clamp(1.75rem, 4vw, 2.4rem);
    }
  }

  .lead {
    font-size: var(--font-size-lg);
    color: var(--color-gray-600);
    margin-top: var(--space-3);
    line-height: 1.5;
  }
}

.web-search {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-top: var(--space-6);
  background: #fff;
  border: 1.5px solid var(--color-primary);
  border-radius: var(--radius-md);
  padding: 6px 6px 6px var(--space-4);
  box-shadow: var(--shadow-md);
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: var(--color-primary-dark);
  }

  svg {
    flex-shrink: 0;
  }
}

.web-search-placeholder {
  flex: 1;
  font-size: var(--font-size-md);
  color: var(--color-gray-400);
  user-select: none;
}

.card-atend-agora {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-5);
  background: #fff;
  border-color: var(--color-success);
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
  }
}

// ============================================================
// SEÇÕES
// ============================================================
.hub-section {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.hub-sec-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: var(--space-4);
  margin-bottom: var(--space-5);

  h2 {
    font-family: var(--font-sans);
    font-size: var(--font-size-2xl);
    font-weight: var(--fw-bold);
    color: var(--color-gray-900);
    letter-spacing: -0.01em;
    margin: 0 0 var(--space-1);
  }

  .sub {
    font-size: var(--font-size-sm);
    color: var(--color-gray-500);
    margin: 0;
    margin-top: 3px;
  }
}

.seelink {
  font-size: var(--font-size-sm);
  font-weight: var(--fw-bold);
  color: var(--color-primary);
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &:hover {
    text-decoration: underline;
  }
}

// ============================================================
// GRADE DE ESPECIALIDADES (5 colunas)
// ============================================================
.esp-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: var(--space-3);

  @media (max-width: 960px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.esp-card {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4);
  cursor: pointer;

  :deep(.ic) {
    color: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: var(--color-primary-light);
    border-radius: var(--radius-lg);
    flex-shrink: 0;
  }

  span {
    font-size: var(--font-size-sm);
    font-weight: var(--fw-semibold);
    color: var(--color-gray-700);
  }
}

// ============================================================
// AVALIAÇÕES (3 colunas)
// ============================================================
.rev-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-4);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
}

.rev-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
}

.stars-sm {
  color: #f59e0b;
  font-size: var(--font-size-md);
  letter-spacing: 2px;
}

.q {
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  line-height: 1.6;
  flex: 1;
  margin: 0;
}

.who {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

// ============================================================
// BENEFÍCIOS (3 colunas)
// ============================================================
.ben-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-4);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.ben-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-5);

  .ic {
    width: 44px;
    height: 44px;
    background: var(--color-accent-light);
    color: var(--color-accent);
    border-radius: var(--radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--space-1);

    &.ic--rx {
      background: var(--color-primary-light);
      color: var(--color-primary);
    }

    &.ic--ex {
      background: var(--color-accent-light, #fce7f1);
      color: var(--color-accent);
    }

    &.ic--at {
      background: var(--color-success-light, #e6f4ea);
      color: var(--color-success, #2e7d32);
    }
  }

  h4 {
    font-family: var(--font-sans);
    font-size: var(--font-size-md);
    font-weight: var(--fw-bold);
    color: var(--color-gray-900);
    margin: 0;
  }

  p {
    font-size: var(--font-size-sm);
    color: var(--color-gray-500);
    margin: 0;
    line-height: 1.5;
  }
}

// Área autenticada usa as classes globais de _patient-shell.scss:
// .area, .area-head, .greet, .hub-2col, .hub-col, .hub-sec-head, .seelink,
// .next-appt, .quick-grid, .quick-card, .mini-stats, .mini-stat

// ── Overrides para o hub logado ───────────────────────────────
// Appbar não sticky no hub (handoff: position static)
.vm-appbar {
  position: static;
}

.vm-appbar-menu {
  display: contents;
}

.vm-appbar-auth {
  display: flex;
  align-items: center;
  gap: var(--space-6);
}

.vm-appbar-toggler {
  display: none;

  .animated-icon span {
    background: var(--color-gray-600) !important;
  }
}

@media (max-width: 991px) {
  .vm-appbar {
    position: relative;
    gap: var(--space-2);
    padding: 0 var(--space-4);
  }

  .vm-appbar .vm-mark {
    margin-right: auto;
  }

  .vm-appbar-toggler {
    display: block;
  }

  .vm-appbar-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 100;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-4);
    background: #fff;
    border-bottom: 1px solid var(--color-gray-200);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);

    &.is-open {
      display: flex;
    }
  }

  .vm-appnav {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-4);
  }

  .vm-appbar-spacer {
    display: none;
  }

  .vm-appbar-auth {
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-2);

    .btn {
      justify-content: center;
    }
  }
}

// Primeiro KPI do resumo alinha com padding do card
.mini-stats .mini-stat:first-child {
  padding-left: 0;
}

// Documentos recentes: ícone com a tag do tipo logo abaixo, como na DocumentosView
.doc-type {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
}

// Card "Próxima consulta" — antes em style inline
.next-appt-info {
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.next-appt-doc {
  gap: var(--space-3);
}

.next-appt-text {
  gap: 1px;
  flex: 1;
  min-width: 0;
}

.next-appt-name {
  font-weight: var(--fw-bold);
  color: var(--color-gray-900);
  font-size: var(--font-size-md);
}

.next-appt-meta {
  font-size: var(--font-size-sm);
  color: var(--color-gray-500);
}

.next-appt-cta {
  align-self: center;
  white-space: nowrap;
  flex: none;
}

.next-appt-wait {
  font-size: var(--font-size-sm);
  color: var(--color-gray-400);
}

@media (max-width: 640px) {
  .next-appt {
    flex-wrap: wrap;
    gap: var(--space-4);
    padding: var(--space-4);
  }

  .next-appt-doc {
    flex-wrap: wrap;
  }

  .next-appt-text {
    flex: 1 1 120px;
  }

  .next-appt-cta {
    flex-basis: 100%;
    white-space: normal;
    text-align: center;
  }
}
</style>
